import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TermsPage = () => (
  <section className="bg-cream-100 py-16">
    <div className="max-w-3xl mx-auto px-5 lg:px-10">
      <Link to="/" className="text-navy-700/70 hover:text-coral-300 inline-flex items-center gap-1 text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Back to home</Link>
      <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">Legal</p>
      <h1 className="font-serif text-navy-700 text-4xl md:text-5xl mt-2">Terms &amp; <span className="italic">Conditions</span></h1>
      <p className="text-sm text-navy-700/60 mt-2">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

      <div className="prose prose-navy max-w-none mt-10 space-y-8 text-navy-700/85 leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">1. Acceptance of Terms</h2>
          <p>By creating an account, purchasing a plan, or using galeriecop (“Service”, “we”, “our”, “us”), you agree to be bound by these Terms &amp; Conditions. If you do not agree, please do not use the Service.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">2. The Service</h2>
          <p>galeriecop provides a private, QR-code based photo, video and message sharing platform for events. Hosts create event galleries; guests upload content via the host’s unique link or QR code without requiring an account.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">3. Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials and for any activity that occurs under your account. Notify us immediately of any unauthorized access.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">4. Plans, Payments &amp; Refunds</h2>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Plans are charged as a one-time fee per event at the listed price plus any applicable taxes.</li>
            <li>All payments are processed securely by Stripe. We do not store full card details on our servers.</li>
            <li>We offer a 14-day money-back guarantee from purchase if you have not yet shared the gallery with guests.</li>
            <li>Upgrades take effect immediately. Downgrades and partial refunds are not available once a gallery has been actively used.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">5. Content &amp; Copyright</h2>
          <p>You and your guests retain 100% ownership and copyright of all photos, videos and messages uploaded. By using the Service you grant galeriecop a limited license to store, transmit and display this content solely to operate the gallery for the duration of your plan.</p>
          <p>You agree not to upload content that is unlawful, infringing, hateful, harassing, or sexually explicit involving minors.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">6. Hosting Period &amp; Data Retention</h2>
          <p>Galleries remain active for the duration described on your selected plan. After expiry, uploads are paused, but content remains accessible for download for the hosting period of your plan. After hosting ends, content may be permanently deleted.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">7. Acceptable Use</h2>
          <p>You agree not to misuse the Service — including but not limited to: attempting unauthorized access, reverse engineering, scraping, sending spam or malware, or interfering with other users’ use of the Service.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">8. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, galeriecop is not liable for any indirect, incidental, special or consequential damages. Our total aggregate liability for any claim arising out of or relating to the Service is limited to the amount you paid in the 12 months preceding the claim.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">9. Termination</h2>
          <p>We may suspend or terminate your access if you violate these Terms. You may delete your account at any time from the dashboard.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">10. Changes</h2>
          <p>We may update these Terms from time to time. Continued use of the Service after a change indicates acceptance of the updated Terms.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-navy-700 italic">11. Contact</h2>
          <p>Questions about these Terms? Email us at <a href="mailto:legal@galeriecop.com" className="text-coral-300 hover:text-coral-400">legal@galeriecop.com</a>.</p>
        </section>
      </div>
    </div>
  </section>
);

export default TermsPage;
